export const initialState = {
  title: '',
  description: '',
  category_groups: [],
  index: '',
  web_app_description: '',
  coming_soon: false
};

export const categoryReducer = function(state, action) {
  switch(action.type) {
    case 'CHANGE_VALUE':
      return {
        ...state,
        ...action.payload,
      };
    case 'ADD_GROUP':
      return {
        ...state,
        category_groups: [...state.category_groups, action.payload],
      };
    case 'REMOVE_GROUP':
      return {
        ...state,
        category_groups: state.category_groups.filter(group => group !== action.payload),
      };
    case 'RESET_GROUPS': {
      return {
        ...state,
        category_groups: [],
      };
    }
    default:
      return state;
  }
};
